import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import date from 'helpers/date'
import React from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'

export default function DetailDrawer({modalDetailDrawer, setModalDetailDrawer}) {
  return (
    <Modal isOpen={modalDetailDrawer} size='small' onClose={() => setModalDetailDrawer(false)}>
        <ModalWrapper>
            <Text name='highlight'>Detalhes do Sorteio</Text>
            <Row marginTop={'15px'}>
                <Text>Nome: </Text>
                <Text marginLeft={'5px'}>{modalDetailDrawer?.item?.giveaway?.name}</Text>
            </Row>
            <Row>
                <Text>Data: </Text>
                <Text marginLeft={'5px'}>{date.format(modalDetailDrawer?.item?.giveaway?.created_at)}</Text>
            </Row>
            <Row>
                <Text>Público do sorteio: </Text>
                <Text marginLeft={'5px'}>{modalDetailDrawer?.item?.giveaway?.scope == 'all' ? 'Todos participantes' : 'Apenas quem fez check-in'}</Text>
            </Row>
            <Row>
                <Text>Quantidade de sorteados: </Text>
                <Text marginLeft={'5px'}>{modalDetailDrawer?.item?.giveaway?.winners_count}</Text>
            </Row>
            <Column horizontalCenter marginTop={'15px'}>
                <Text type='bold'>Ganhador</Text>
                <ContentWinners>
                    <>
                        <Row>
                            <Text>Nome:</Text>
                            <Text marginLeft={'5px'}>{modalDetailDrawer?.item?.winner?.user?.name}</Text>
                        </Row>
                        <Row>
                            <Text>E-mail:</Text>
                            <Text marginLeft={'5px'}>{modalDetailDrawer?.item?.winner?.user?.email}</Text>
                        </Row>

                        <Row>
                            <Text>Código do Ticket:</Text>
                            <Text marginLeft={'5px'}>{modalDetailDrawer?.item?.winner?.ticket?.code}</Text>
                        </Row>
                    </>
                
                </ContentWinners>
            </Column>
        </ModalWrapper>
    </Modal>
  )
}

const ModalWrapper = styled(Column)`
    padding: 10px;

    & > p {
        text-transform: capitalize;
    }
`;

const ContentWinners = styled(Column)`
    margin-top: 10px;
    align-items: flex-start;
`;

